module.exports = __webpack_public_path__ + "img/40_69_004_250.cb3dc88a.jpg";